import { TAB_HIDE, TAB_SHOW } from '../../../../../common/tabs/tabs.constants';
import { IDS } from '../pnp-doc.constants';
import { getDocumentHistoryDetails, getDocumentReviewerApproverDetails } from '../pnp-doc.actions';
/**
 * @const {object}
 * @memberOf module:policies
 */
export const pnpDocumentHistory = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, DocumentManager) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ policies }) => ({
                pnpDocument: policies.pnpDocument
            }), {
                getDocumentHistoryDetails,
                getDocumentReviewerApproverDetails
            })(this);
        }

        this.onSelect = ({ item }) => {
            this.getDocumentReviewerApproverDetails(item.vdoId).then(() => {
                this.getDocumentHistoryDetails(item.id).then(() => {
                    $ngRedux.dispatch({
                        type: TAB_HIDE,
                        id: IDS.app_policies_documents_manage,
                        state: [IDS.app_policies_documents_manage_history_details]
                    });
                    this.timeout = setTimeout(() => {
                        $ngRedux.dispatch({
                            type: TAB_SHOW,
                            id: IDS.app_policies_documents_manage,
                            state: [IDS.app_policies_documents_manage_history_details],
                            stateParams: { id: item.id }
                        });
                    }, 1000)

                });
            });
        };

        this.onDownloadButton = ({ item }) => {
            DocumentManager.downloadFile(item.path);
        };

        this.onReset = (event) => {

        };

        this.$onDestroy = () => {
            this.unsubscribe();
            clearTimeout(this.timeout);
        }
    },
    template: `
        <pnp-document-history-grid
            on-select="$ctrl.onSelect($event)" 
            on-download="$ctrl.onDownloadButton($event)"
            on-reset="$ctrl.onReset($event)">
        </pnp-document-history-grid>
    `
};
